/**
 * The project page's split layout, as rules rather than as markup.
 *
 * Two things live here because they cannot be checked by looking at the page:
 * whether the discussion column is showing, and whether the CSS breakpoint and
 * the component agree about where the split stops being a split.
 */

const STORAGE_KEY = 'tap.project.discussionOpen';

/**
 * Whether the discussion column was left open.
 *
 * Defaults to OPEN, and the distinction matters: a missing key is somebody who
 * has never touched the toggle, and they should meet the feature rather than
 * have to discover it. Only an explicit "false" collapses it.
 */
export function loadDiscussionOpen(storage: Pick<Storage, 'getItem'>): boolean {
  try {
    return storage.getItem(STORAGE_KEY) !== 'false';
  } catch {
    // Private browsing. The panel still works this session.
    return true;
  }
}

export function saveDiscussionOpen(storage: Pick<Storage, 'setItem'>, open: boolean): void {
  try {
    storage.setItem(STORAGE_KEY, open ? 'true' : 'false');
  } catch {
    // A full quota is not worth a broken page.
  }
}

/** What the toggle says and does right now. */
export function discussionToggleLabel(open: boolean): string {
  // Says what the click will DO, not what the state is. "Discussion" as a
  // label on a pressed button leaves somebody guessing whether pressing it
  // opens or closes.
  return open ? 'Hide discussion' : 'Show discussion';
}
